import { FULFILL_CANDLES_DATA, CLEAR_STATE } from '../constants'
import { ClearState } from '../actions/commonActions'
import { FulfillCandlesData } from '../actions/signalsActions'
import { CandlesData } from '../types'

export function candles(
  state = defaultState,
  action: FulfillCandlesData | ClearState
): CandlesData {
  switch (action.type) {
    case FULFILL_CANDLES_DATA: {
      const { candlesData: data } = action
      if (data.symbol !== state.symbol || data.resolution !== state.resolution) return data
      return { ...state, bars: new Map([...state.bars, ...data.bars]) }
    }
    case CLEAR_STATE:
      return defaultState
    default:
      return state
  }
}

const defaultState: CandlesData = { symbol: '', resolution: 0, bars: new Map() }
